{
  "version": 1,
  "asset_id": "0ea79472-bc03-4fbd-8be0-2e157741b3ee",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/0ea79472-bc03-4fbd-8be0-2e157741b3ee/hero-home.mp4",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/0ea79472-bc03-4fbd-8be0-2e157741b3ee/hero-home.mp4",
  "original_filename": "hero-home.mp4",
  "size": 837423,
  "content_type": "video/mp4",
  "created_at": "2026-09-27T18:56:17Z"
}
